import React, { useState, useEffect } from 'react'
import { MDBIcon } from 'mdb-react-ui-kit'
import { useNavigate } from 'react-router-dom'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { Country,getStatesOfCountry,getCitiesOfState,getAllCountries } from 'country-state-city';

function Step3({ data, setActiveStep, title, getUpdate }) {
  const navigate = useNavigate()
  const [addressLine1, setAddressLine1] = useState('')
  const [addressLine2, setAddressLine2] = useState('')
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [pincode, setPincode] = useState('')
  const [paddressLine1, setpAddressLine1] = useState('')
  const [paddressLine2, setpAddressLine2] = useState('')
  const [pcity, setpCity] = useState('')
  const [pstate, setpState] = useState('')
  const [ppincode, setpPincode] = useState('')
  const [states, setStates] = useState([])
  const [cities, setCities] = useState([])
  const [pcities, setpCities] = useState([])
  const [isSameAddress, setIsSameAddress] = useState(false)
  const [country, setCountry] = useState('India')
  const [countryCode, setCountryCode] = useState('IN')
  
  
  const [open, setOpen] = React.useState(false);
  console.log("state",state)

  // Load Indian states on component mount
  useEffect(() => {
    const indianStates = getStatesOfCountry(countryCode);
    console.log("indianStates",indianStates)
    setStates(indianStates);
  }, [countryCode])

  // Handle state change for correspondence address
  const handleStateChange = (e) => {
    const selectedStateCode = e.target.value;
    setState(selectedStateCode);
    setCity(''); // Reset city when state changes
    
    if (selectedStateCode) {
      const stateCities =getCitiesOfState(countryCode, selectedStateCode);
      setCities(stateCities);
    } else {
      setCities([]);
    }
  }

  // Handle state change for permanent address
  const handlePermanentStateChange = (e) => {
    const selectedStateCode = e.target.value;
    setpState(selectedStateCode);
    setpCity(''); // Reset city when state changes
    
    if (selectedStateCode) {
      const stateCities =getCitiesOfState(countryCode, selectedStateCode);
      setpCities(stateCities);
    } else {
      setpCities([]);
    }
  }

  // UPDATE ADDRESS DETAILS OF USER
  async function updateAddress(event) {
    event.preventDefault()
    setOpen(true)

    await fetch(`/api/v2/address-details/${data.personalDetails._id}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        addressLine1,
        addressLine2,
        city,
        state,
        pincode,
        paddressLine1,
        paddressLine2,
        pcity,
        pstate,
        ppincode
      })
    })
      .then((response) => response.json())
      .then((data) => {
        setOpen(false)
        if (data.success) {
          alert(data.message);
          setActiveStep(4)
          getUpdate()
        }
        else {
          alert(data.message)
        }
      })
      .catch((error) => {
        setOpen(false)
        alert('Error updating address')
      })
  }

  const nextStep = () => {
    if (data.city) {
      setActiveStep(4)
    }
  }

  useEffect(()=>{
    if(data.country){
      const countryData = getAllCountries().find(c => c.isoCode === countryCode);
      if(countryData){
        setCountry(countryData.name);
        setCountryCode(countryData.isoCode);
      }
    }
  },[country])

  // useEffect(()=>{
  //   if(data.state){
  //     const stateCities = getCitiesOfState(countryCode, data.state);
  //     setCities(stateCities);
  //   }
  // },[state])

  useEffect(() => {
    if (data.personalDetails) {
      setPincode(data.personalDetails.pincode || '')
      setAddressLine1(data.personalDetails.addressLine1 || '')
      setAddressLine2(data.personalDetails.addressLine2 || '')
      setState(data.personalDetails.state || '')
      setCity(data.personalDetails.city || '')
      setpPincode(data.personalDetails.ppincode || '')
      setpAddressLine1(data.personalDetails.paddressLine1 || '')
      setpAddressLine2(data.personalDetails.paddressLine2 || '')
      setpState(data.personalDetails.pstate || '')
      setpCity(data.personalDetails.pcity || data.state || '')
      if(data.country == "India"){
        setCountryCode("IN")
      }
      if(data.country && data.country != "India"){
        const countryData = getAllCountries().find(c => c.name === data.country);
        if(countryData){
          setCountryCode(countryData.isoCode);
          setCountry(data.country);
        }
      }
      

      // Load cities if state exists
      if (data.personalDetails.state) {
        const stateCities = getCitiesOfState(countryCode, data.personalDetails.state);
        setCities(stateCities);
      }
      if (data.personalDetails.pstate) {
        const pStateCities = getCitiesOfState(countryCode, data.personalDetails.pstate);
        setpCities(pStateCities);
      }
    }
  }, [data])

  const copyAddress = () => {
    setIsSameAddress(true)
    setpPincode(pincode)
    setpAddressLine1(addressLine1)
    setpAddressLine2(addressLine2)
    setpState(state)
    setpCity(city)
    
    // Also copy the cities list
    if (state) {
      const stateCities = getCitiesOfState(countryCode, state);
      setpCities(stateCities);
    }
  }

  const DonotCopy = () => {
    setIsSameAddress(false)
    setpPincode("")
    setpAddressLine1("")
    setpAddressLine2("")
    setpState("")
    setpCity("")
    setpCities([])
  }

  return (
    <div className='paymentPage'>
      <h2 className='applicationCSS4 text-center pt-2 text-black font-bold'>{title}</h2>
      <div className='applicationCSS3'>
        <img className='fluid applicationCSS2' style={{ margin: 'auto' }} src="https://ucarecdn.com/e853544e-4a83-4196-9e8d-4fe7520ca2f4/step3.png" alt="" />
      </div>

      {/* ********************************   form                **************************** */}
      <div className='p-4 bg-white bootstrap-form applicationCSS' >
        <form className="row g-3">
          {/* Correspondence Address Section */}
          <div className="col-md-12 ">
            <p className='text-[18px] font-bold' style={{ textDecoration: 'underline' }}>Correspondence Address :- </p>
            <label htmlFor="inputEmail4" className="form-label text-black font-bold">Address Line 1</label><span className='text-red-600 text-xl font-bold'>*</span>
            <input 
              placeholder='Address Line 1' 
              style={{ outline: 'none' }} 
              type="text" 
              value={addressLine1} 
              onChange={(e) => { setAddressLine1(e.target.value) }} 
              className="form-control shadow-none text-black" 
              id="inputEmail4" 
            />
          </div>
          <div className="col-md-12">
            <label htmlFor="inputPassword4" className="form-label text-black font-bold">Address Line 2</label><span className='text-red-600 text-xl font-bold'>*</span>
            <input 
              placeholder='Address Line 2' 
              type="text" 
              className="form-control shadow-none text-black" 
              value={addressLine2} 
              onChange={(e) => { setAddressLine2(e.target.value) }} 
              id="inputPassword4" 
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="inputCountry" className="form-label text-black font-bold">Country</label><span className='text-red-600 text-xl font-bold'>*</span>
            <input 
              disabled 
              placeholder='Country' 
              type="text" 
              className="cursor-not-allowed form-control shadow-none text-black" 
              value={country} 
              id="inputCountry" 
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="inputState" className="form-label text-black font-bold">State</label><span className='text-red-600 text-xl font-bold'>*</span>
            <select
              id="inputState"
              className="form-control shadow-none text-black"
              value={state}
              onChange={handleStateChange}
            >
              <option value="">Select State</option>
              {states.map((stateItem) => (
                <option key={stateItem.isoCode} value={stateItem.isoCode}>
                  {stateItem.name}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-3">
            <label htmlFor="inputCity" className="form-label text-black font-bold">City</label><span className='text-red-600 text-xl font-bold'>*</span>
            <select
              id="inputCity"
              className="form-control shadow-none text-black"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              disabled={!state}
            >
              <option value="">Select City</option>
              {cities.map((cityItem) => (
                <option key={cityItem.name} value={cityItem.name}>
                  {cityItem.name}
                </option>
              ))}
            </select>
          </div>
          {
            data.application_type !== "NRI" &&

          <div className="col-md-3">
            <label htmlFor="inputPincode" className="form-label text-black font-bold">Pincode</label><span className='text-red-600 text-xl font-bold'>*</span>
            <input 
              placeholder='Enter Your Pincode' 
              type="text" 
              className="form-control shadow-none text-black" 
              value={pincode} 
              onChange={(e) => { setPincode(e.target.value) }} 
              id="inputPincode" 
            />
          </div>
          }

          {/* Permanent Address Section */}
          <div className="col-md-12 ">
            <p className='text-[18px] font-bold' style={{ textDecoration: 'underline' }}>Permanent Address :- </p>
            <p className='flex mt-[-13px] items-center'>
              Same as Correspondence Address &nbsp; 
              <div>
                <input 
                  onChange={(e) => e.target.checked && copyAddress()} 
                  type="radio" 
                  id="html" 
                  name="fav_language" 
                  checked={isSameAddress}
                />
                <label htmlFor="html">&nbsp; Yes</label> &nbsp; 
                <input 
                  onChange={(e) => e.target.checked && DonotCopy()} 
                  type="radio" 
                  id="css" 
                  name="fav_language" 
                  checked={!isSameAddress}
                />
                <label htmlFor="css"> &nbsp; No</label>
              </div>
            </p>
            <label htmlFor="pinputEmail4" className="form-label text-black font-bold">Address Line 1</label><span className='text-red-600 text-xl font-bold'>*</span>
            <input 
              placeholder='Address Line 1' 
              style={{ outline: 'none' }} 
              type="text" 
              value={paddressLine1} 
              onChange={(e) => { setpAddressLine1(e.target.value) }} 
              className="form-control shadow-none text-black" 
              id="pinputEmail4" 
              disabled={isSameAddress}
            />
          </div>
          <div className="col-md-12">
            <label htmlFor="pinputPassword4" className="form-label text-black font-bold">Address Line 2</label><span className='text-red-600 text-xl font-bold'>*</span>
            <input 
              placeholder='Address Line 2' 
              type="text" 
              className="form-control shadow-none text-black" 
              value={paddressLine2} 
              onChange={(e) => { setpAddressLine2(e.target.value) }} 
              id="pinputPassword4" 
              disabled={isSameAddress}
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="pinputCountry" className="form-label text-black font-bold">Country</label><span className='text-red-600 text-xl font-bold'>*</span>
            <input 
              disabled 
              placeholder='Country' 
              type="text" 
              className="cursor-not-allowed form-control shadow-none text-black" 
              value={country} 
              id="pinputCountry" 
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="pinputState" className="form-label text-black font-bold">State</label><span className='text-red-600 text-xl font-bold'>*</span>
            <select
              id="pinputState"
              className="form-control shadow-none text-black"
              value={pstate}
              onChange={handlePermanentStateChange}
              disabled={isSameAddress}
            >
              <option value="">Select State</option>
              {states.map((stateItem) => (
                <option key={stateItem.isoCode} value={stateItem.isoCode}>
                  {stateItem.name}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-3">
            <label htmlFor="pinputCity" className="form-label text-black font-bold">City</label><span className='text-red-600 text-xl font-bold'>*</span>
            <select
              id="pinputCity"
              className="form-control shadow-none text-black"
              value={pcity}
              onChange={(e) => setpCity(e.target.value)}
              disabled={!pstate || isSameAddress}
            >
              <option value="">Select City</option>
              {pcities.map((cityItem) => (
                <option key={cityItem.name} value={cityItem.name}>
                  {cityItem.name}
                </option>
              ))}
            </select>
          </div>
          {
            data.application_type !== "NRI" &&

          <div className="col-md-3">
            <label htmlFor="pinputPincode" className="form-label text-black font-bold">Pincode</label><span className='text-red-600 text-xl font-bold'>*</span>
            <input 
              placeholder='Enter Your Pincode' 
              type="text" 
              className="form-control shadow-none text-black" 
              value={ppincode} 
              onChange={(e) => { setpPincode(e.target.value) }} 
              id="pinputPincode" 
              disabled={isSameAddress}
            />
          </div>
          }
        </form>
        <div className="col-12 flex justify-between flex-row-reverse mt-2">
          <button 
            onClick={updateAddress} 
            className="btn btn-primary"
            disabled={!addressLine1 || !addressLine2 || !city || !state || 
                     !paddressLine1 || !paddressLine2 || !pcity || !pstate }
          >
            Save & Continue
          </button>
          <button onClick={() => { setActiveStep(2) }} className="btn btn-primary">Back</button>
        </div>
      </div>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  )
}

export default Step3